import { Environment } from "src/app/classes/flow/base/Environment";

export const ENVIRONMENT: Environment = {
  PRODUCTION: false,
  ORGANISATION: "Gemeente Emmen Development",
  API_URL: "https://dev.api.epf.emmengeeftenergie.nl/",
  SOCIALS: {
    SLOGAN: "Emmen geeft energie",
    LINKS: {
      MAIN: "https://emmengeeftenergie.nl/",
      PRIVACY: "https://www.emmengeeftenergie.nl/Beheer/Privacyverklaring/default.aspx",
      DISCLAIMER: "",
    },
  },
  PORTAL_URL: "https://dev.portal.emmengeeftenergie.nl/",
  EXTRA_TRANSLATIONS_SUFFIX: [],
  MODULES: [
    "EMPTY_PDF",
    "TIME_SLOTS",
    "COACH_FINISH_REQUEST",
    "PHONE_NUMBER_REQUIRED",
    "FILLED_REQUEST_REDIRECT",
    "NOTE",
    "DM",
    "NEW_REQUEST_COORDINATOR",
  ],
  ALLOWED_SPECIALTIES: [1],
  AREA_OF_OPERATIONS: {
    MATCHES: [],
  },
  CUSTOM_HEADER_LOGOS: [],
  REDIRECTS: [["coachEnergyConsultComponent", "https://dev.fixteam.emmengeeftenergie.nl/request", "Doorverwijzen naar Fixteam Emmen"]],
};
